import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'
import { MediaImage, MediaImageProps } from '../base'

export interface Props extends ScaleProps<MediaImageProps> {}

export default function SMediaImage({ mediaId, ...props }: Props) {
  const { styleProps, rest } = useScaleProps(props)
  const { w, h, ...restStyleProps } = styleProps
  const dimensions = { height: h, width: w }

  return <MediaImage mediaId={mediaId} {...dimensions} {...styleProps} {...rest} />
}
